export default "__VITE_ASSET__DUU$rYEC__"